/*!
 *
 * Copyright 2018 - acrazing
 *
 * @author acrazing joking.young@gmail.com
 * @since 2018-01-06 12=23=01
 * @version 1.0.0
 * @desc constants.ts
 */
export var KeyVersions = '__mobx_sync_versions__';
export var KeyDefaultKey = '__mobx_sync__';
export var KeyActionName = '__PERSIST__';
export var KeyNodeVersion = '__mobx_sync_this__';
export var KeyIgnores = '__mobx_ignores__';
export var KeyFormat = '__mobx_sync_format__';
export var KeyInject = '__mobx_sync_inject__';
//# sourceMappingURL=keys.js.map